export default __webpack_public_path__ + "static/media/life.1295d678.svg";